import * as DISCOVERY_ACTION from 'constant/action/discovery'
import { handleActions } from 'redux-actions'

const initialState = {
  discoveries: {},
  pagination: {},
  searchTerm: ''
}

export default handleActions(
  {
    [DISCOVERY_ACTION.UPDATE_DISCOVERIES]: (state, action) => ({
      ...state,
      discoveries: action.payload
    }),
    [DISCOVERY_ACTION.UPDATE_DISCOVERY_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [DISCOVERY_ACTION.UPDATE_DISCOVERY_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    })
  },
  initialState
)
